import sha256 from 'crypto-js/sha256'
import { useSettingsStore } from 'Store/settings'

export function encrypGA4Value(value) {
  const settingsStore = useSettingsStore()
  if (!settingsStore.getBrandId) return null

  // we do hashing twice here as requirement
  // https://umami-me.atlassian.net/wiki/spaces/TECH/pages/2188312628/Google+Analytcs+4+GA4
  const salt = sha256(settingsStore.getBrandId.toString()).toString()
  return sha256(`${salt}${value}`).toString()
}
